// System Defaults is only to maintain the defaults
export default {
    kitTypeId : "000000"
}